import type { PartialMessageProps } from '@zg-rentals/backend-styled-components';

type HelpArticle = {
  title: Array<PartialMessageProps>;
  contents: Array<Array<PartialMessageProps>>;
};

type HelpArticlesProps = {
  heading?: string;
  helpArticles: Array<HelpArticle>;
};

const HelpArticles = ({ heading = '', helpArticles = [] }: Partial<HelpArticlesProps> = {}) => {
  return {
    heading: String(heading),
    helpArticles: helpArticles.map((h) => h),
  };
};

// @ts-expect-error
export { HelpArticle, HelpArticles, HelpArticlesProps };
